import React, { Component, Fragment } from "react";
import { Footer } from "../general";
import {
  ModernHeader,
  ModernHero,
  ModernServices,
  ModernCTA,
  ModernClients,
} from "../modern";

export class Home extends Component {
  render = () => {
    return (
      <Fragment>
        <ModernHeader />
        <ModernHero />
        <ModernServices />
        <ModernCTA />
        <ModernClients />
        <Footer />
      </Fragment>
    );
  };
}

export default Home;
